export default __webpack_public_path__ + "static/media/deposites.aee7b700.svg";